import { render, staticRenderFns } from "./dictionary.vue?vue&type=template&id=18acb750&scoped=true&"
import script from "./dictionary.vue?vue&type=script&lang=js&"
export * from "./dictionary.vue?vue&type=script&lang=js&"
import style0 from "./dictionary.vue?vue&type=style&index=0&id=18acb750&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18acb750",
  null
  
)

export default component.exports